<!--<div class="loader" *ngIf="loaderService.isLoading$ | async">
    <div class="loader-spinner">
        <img src="../../../../assets/img/loader.svg" alt="" />
    </div>
</div>-->
<div id="event" *ngIf="event | async">
  <div class="event-navigation">
    <div class="breadcrumbs">
      <a routerLink="/events">
        <i class="fa-solid fa-house"></i>
      </a>
      <i class="fa-solid fa-circle"></i>
      <a routerLink="/events">
        <span>{{ "EVENTS" | transloco }}</span>
      </a>
    </div>

    <div class="nav-title">
      <div class="arrow" (click)="onBackClicked()">
        <i class="fa-solid fa-arrow-left"></i>
      </div>

      <div class="event-title">
        <span class="c-event-title">{{ (event | async)?.name }}</span>
        <a class="share" [cdkCopyToClipboard]="clipBoardValue" (click)="onCopy()">
          <span>{{ (isAAUMembership ? 'SHARE' : "COPY_LINK") | transloco
            }}</span>
          <i class="fa-solid fa-link"></i>
          <div class="copied" *ngIf="isCopied" class="copied" [class.visible]="isCopied">
            {{ "COPIED" | transloco }}
          </div>
        </a>
      </div>
    </div>

    <div class="event-menu" *ngIf="menu?.length > 0">
      <ng-container *ngFor="let item of menu">
        <a *ngIf="item.type !== MenuItemType.statistics" class="menu-option"
          [ngClass]="{ active: activeMenuItem === item.type }" (click)="activeMenuItem = item.type" [href]="item.url">
          <span>{{ item.name | transloco }}</span>
        </a>
        <a class="menu-option" *ngIf="item.type === MenuItemType.statistics" (click)="$event.stopPropagation()"
          [matMenuTriggerFor]="statisticsMenu" [matMenuTriggerData]="{ item: item }">
          <span>{{ item.name | transloco }}</span>
        </a>
      </ng-container>

      <mat-menu #statisticsMenu="matMenu" xPosition="after" yPosition="below" class="statistics-menu">
        <ng-template matMenuContent let-item="item">
          <div class="menu-items">
            <a *ngFor="let subItem of item.subMenu; let i = index" [href]="subItem.url">
              <span class="item-title">{{ subItem.name | transloco }}</span>
            </a>
          </div>
        </ng-template>
      </mat-menu>
    </div>
  </div>

  <div class="wrap-event">
    <div class="event">
      <div class="event-details">
        <div *ngIf="!isClubMembershipEvent && !isAthleteOrNonAthleteMembership" class="event-date">
          <div class="event-period">
            <div class="event-period-days">
              <span class="title">{{ "EVENT_DATES" | transloco }}</span>
              <span class="amount">{{
                eventsService.checkSameDates(
                (event | async)?.eventStartDate,
                (event | async)?.eventEndDate
                )
                }}</span>
            </div>
            <div class="event-period_registration_days-left"
              *ngIf="!isMembershipLicensing && !isPractiseEvent && daysLeft !== NO_REG_END_DATE">
              <span class="title">{{ "DAYS_LEFT" | transloco }}</span>
              <span class="amount">{{ daysLeft >= 0 ? daysLeft : 0 }}</span>
            </div>
          </div>
        </div>


        <div class="c-club-m-event-first-wrapper">
          <div *ngIf="isClubMembershipEvent || isAthleteOrNonAthleteMembership" class="c-event-date">
            <span class="c-event-period-label">{{ "PERIOD" | transloco }}</span>

            <span class="c-event-period-value">{{
              eventsService.checkSameDates(
              (event | async)?.eventStartDate,
              (event | async)?.eventEndDate
              )
              }}
            </span>
          </div>

          <!-- <img *ngIf="isClubMembershipEvent || isAthleteOrNonAthleteMembership" src="assets/img/aau_official_app-sm.png"
            alt="AAU Official App" class="c-logo-sm"> -->
        </div>

        <div class="event-info" [ngClass]="{ 'event-info-no-border-bottom': isAAUMembership }">
          <div class="event-info-days"
            *ngIf="!isMembershipLicensing && !isPractiseEvent && !isClubMembershipEvent && !isAthleteOrNonAthleteMembership && daysLeft !== 3.14">
            <div class="event-info-days__registartion-days">
              <span class="title">{{ "REGISTRATION_DAYS" | transloco }}</span>
              <span class="amount">{{
                moment((event | async)?.regEndDate).format("MMM DD, YYYY")
                }}</span>
            </div>
          </div>

          <div class="event-info__action-buttons" [ngClass]="{ 'c-margin-top': isAAUMembership }">
            <div class="end-buttons">
              <ng-container *ngFor="let button of clubsButtons">
                <button *ngIf="true" class="club-button" [ngClass]="button.classValue"
                  (click)="goToMembershipClub(button.value)">{{button.label |transloco}}</button>
              </ng-container>
            </div>

            <button *ngIf="isMembershipLicensing || isAthleteOrNonAthleteMembership" class="c-primary-button"
              [class.u-primary-button]="isUSAGRMembership || isJKFAthleteMembership" type="button"
              (click)="goToMembershipEvent(isMembershipLicensing ? 'LICENSING' : 'ATHLETE_NON_ATHLETE')">
              {{ "GET_STARTED" | transloco }}
            </button>

            <button *ngIf="isPractiseEvent" class="c-primary-button" [class.u-primary-button]="isUSAGRMembership"
              type="button" (click)="goToMembershipEvent('PRACTICE')">
              {{ "GET_STARTED" | transloco }}
            </button>

            <!--            <button class="register-now lg" type="button" *ngIf="isAssistedRegistrationAllowed" (click)="handleAssistedRegistration(false)">-->
            <!--              {{"REGISTER_ATHLETES" | transloco}}-->
            <!--            </button>-->

            <!--            <button class="register-now lg" type="button" *ngIf="isAssistedRegistrationAllowed" (click)="handleAssistedRegistration(true)">-->
            <!--              {{"REGISTER_NON_ATHLETES" | transloco}}-->
            <!--            </button>-->

            <button *ngIf="currentEvent?.type !== 'TICKETS'
              && !isClubMembershipEvent
              && !isMembershipLicensing
              && !isPractiseEvent
              && !isMultiSubEvents
              && !isAthleteOrNonAthleteMembership" class="register-now" type="button" (click)="handleRegisterNow()"
              [disabled]="!checkRegistrationEnabled(event | async)">
              {{ "REGISTER_NOW" | transloco }}
            </button>

            <button *ngIf="(event | async)?.eventConfig?.isAllowedToBuyTicket
                && !isClubMembershipEvent
                && !isMembershipLicensing
                && !isPractiseEvent
                && !isAthleteOrNonAthleteMembership" class="buy-tickets" (click)="handleBuyTickets()">
              {{ "BUY_TICKETS" | transloco }}
            </button>

            <div *ngIf="showMembershipPurchaseWarning" class="c-membership-warning">
              <div class="c-warning-icon">
                <svg xmlns="http://www.w3.org/2000/svg" style="width: 17px; height: 17px;" width="20" height="20"
                  viewBox="0 0 20 20" fill="none">
                  <path
                    d="M18.3334 10C18.3334 14.6034 14.6021 18.3334 10 18.3334C5.39797 18.3334 1.66669 14.6034 1.66669 10C1.66669 5.39931 5.39797 1.66669 10 1.66669C14.6021 1.66669 18.3334 5.39931 18.3334 10ZM10 11.6801C9.14636 11.6801 8.45432 12.3722 8.45432 13.2258C8.45432 14.0795 9.14636 14.7715 10 14.7715C10.8537 14.7715 11.5457 14.0795 11.5457 13.2258C11.5457 12.3722 10.8537 11.6801 10 11.6801ZM8.53251 6.12415L8.78177 10.694C8.79343 10.9079 8.97025 11.0753 9.18439 11.0753H10.8156C11.0298 11.0753 11.2066 10.9079 11.2183 10.694L11.4675 6.12415C11.4801 5.89317 11.2962 5.69895 11.0649 5.69895H8.9351C8.70378 5.69895 8.51991 5.89317 8.53251 6.12415Z"
                    fill="#F3F6F6" />
                </svg>
              </div>
              <div class="c-warning-text">
                <strong>{{ "MEMBERSHIP_WARNING_STOP" | transloco }}</strong>
                <span>{{ "MEMBERSHIP_WARNING_RENEWAL" | transloco }}</span>
              </div>
            </div>

          </div>
          <div class="event-info__sub-events" *ngIf="isMultiSubEvents"
            [ngClass]="{'c-padding-bottom-zero': isAnyOfficialsRegistrationEnabled()}">
            <ng-container *ngFor="let subEvent of subEvents">
              <div class="sub-event w-100 d-flex">
                <div class="sub-event-info">
                  <div class="sub-event-photo-wrapper">
                    <ng-container *ngIf="subEvent.processedImage">
                      <img [src]="subEvent.processedImage.url"
                        [ngClass]="'sub-event-photo ' + getAspectRatioClass(subEvent.processedImage)" />
                    </ng-container>
                    <ng-container *ngIf="!subEvent.processedImage">
                      <img class="sub-event-photo narrow-image" alt="uventex logo" src="/assets/img/default-logo.png" />
                    </ng-container>
                    <!--                    <img [src]="subEvent.photoUrl" [alt]="subEvent.name + ' logo'">-->
                  </div>
                  <span class="sub-event-name">{{ subEvent.name }}</span>
                </div>
                <a class="copy sub-event-registration-button"
                  [class.disabled]="!checkRegistrationEnabled(event | async)"
                  (click)="handleRegisterNow(subEvent.id)">Register now</a>
              </div>
            </ng-container>
          </div>
          <div class="event-info__action-buttons"
            [ngClass]="{ 'c-margin-zero': isMultiSubEvents && !isAnyOfficialsRegistrationEnabled() }">
            <button
              *ngIf="(event | async)?.isSportshubOfficialRegistrationAllowed && (event | async)?.eventConfig?.configItems?.REGISTRATION_OFFICIAL"
              [disabled]="!checkRegistrationEnabled(event | async)" class="register-role-button"
              (click)="handleRegisterAsOfficial(RegistrationType.REGISTRATION_OFFICIAL)">
              <svg class="register-role-button-img" xmlns="http://www.w3.org/2000/svg" width="9" height="10"
                viewBox="0 0 9 10" fill="none">
                <path
                  d="M3.18896 5C2.21826 5 1.43896 4.2207 1.43896 3.25C1.43896 2.29297 2.21826 1.5 3.18896 1.5C4.146 1.5 4.93896 2.29297 4.93896 3.25C4.93896 4.2207 4.146 5 3.18896 5ZM4.40576 5.4375C5.41748 5.4375 6.25146 6.27148 6.25146 7.2832V7.84375C6.25146 8.21289 5.95068 8.5 5.59521 8.5H0.782715C0.413574 8.5 0.126465 8.21289 0.126465 7.84375V7.2832C0.126465 6.27148 0.946777 5.4375 1.9585 5.4375H2.19092C2.4917 5.58789 2.8335 5.65625 3.18896 5.65625C3.54443 5.65625 3.87256 5.58789 4.17334 5.4375H4.40576ZM8.82178 3.6875C8.89014 3.75586 8.89014 3.85156 8.82178 3.91992L6.89404 5.83398C6.82568 5.90234 6.72998 5.90234 6.66162 5.83398L5.54053 4.71289C5.48584 4.64453 5.48584 4.53516 5.54053 4.48047L5.92334 4.09766C5.9917 4.0293 6.10107 4.0293 6.15576 4.09766L6.78467 4.72656L8.22021 3.30469C8.2749 3.23633 8.38428 3.23633 8.43896 3.30469L8.82178 3.6875Z"
                  fill="var(--customizable-primary-color)" />
              </svg>
              {{ "REGISTER_AS_OFFICIAL" | transloco }}
            </button>
            <button
              *ngIf="(event | async)?.isSportshubOfficialRegistrationAllowed && (event | async)?.eventConfig?.configItems?.REGISTRATION_COACH"
              [disabled]="!checkRegistrationEnabled(event | async)" class="register-role-button"
              (click)="handleRegisterAsOfficial(RegistrationType.REGISTRATION_COACH)">
              <svg class="register-role-button-img" xmlns="http://www.w3.org/2000/svg" width="9" height="10"
                viewBox="0 0 9 10" fill="none">
                <path
                  d="M1.60721 3.35714C1.78132 3.35714 1.92864 3.50446 1.92864 3.67857V7.32143C1.92864 7.50893 1.78132 7.64286 1.60721 7.64286H0.964355C0.776855 7.64286 0.642927 7.50893 0.642927 7.32143V5.92857H0.321498C0.254534 5.92857 0.214355 5.88839 0.214355 5.82143V5.17857C0.214355 5.125 0.254534 5.07143 0.321498 5.07143H0.642927V3.67857C0.642927 3.50446 0.776855 3.35714 0.964355 3.35714H1.60721ZM8.67864 5.07143C8.73221 5.07143 8.78578 5.125 8.78578 5.17857V5.82143C8.78578 5.88839 8.73221 5.92857 8.67864 5.92857H8.35721V7.32143C8.35721 7.50893 8.20989 7.64286 8.03578 7.64286H7.39293C7.20543 7.64286 7.0715 7.50893 7.0715 7.32143V3.67857C7.0715 3.50446 7.20543 3.35714 7.39293 3.35714H8.03578C8.20989 3.35714 8.35721 3.50446 8.35721 3.67857V5.07143H8.67864ZM6.3215 2.5C6.4956 2.5 6.64293 2.64732 6.64293 2.82143V8.17857C6.64293 8.36607 6.4956 8.5 6.3215 8.5H5.67864C5.49114 8.5 5.35721 8.36607 5.35721 8.17857V5.92857H3.64293V8.17857C3.64293 8.36607 3.49561 8.5 3.3215 8.5H2.67864C2.49114 8.5 2.35721 8.36607 2.35721 8.17857V2.82143C2.35721 2.64732 2.49114 2.5 2.67864 2.5H3.3215C3.49561 2.5 3.64293 2.64732 3.64293 2.82143V5.07143H5.35721V2.82143C5.35721 2.64732 5.49114 2.5 5.67864 2.5H6.3215Z"
                  fill="var(--customizable-primary-color)" />
              </svg>
              {{ "REGISTER_AS_COACH" | transloco }}
            </button>

            <button
              *ngIf="(event | async)?.isSportshubOfficialRegistrationAllowed && (event | async)?.eventConfig?.configItems?.REGISTRATION_JUDGE"
              [disabled]="!checkRegistrationEnabled(event | async)" class="register-role-button"
              (click)="handleRegisterAsOfficial(RegistrationType.REGISTRATION_JUDGE)">
              <svg class="register-role-button-img" xmlns="http://www.w3.org/2000/svg" width="9" height="10"
                viewBox="0 0 9 10" fill="none">
                <path
                  d="M3.18896 5C2.21826 5 1.43896 4.2207 1.43896 3.25C1.43896 2.29297 2.21826 1.5 3.18896 1.5C4.146 1.5 4.93896 2.29297 4.93896 3.25C4.93896 4.2207 4.146 5 3.18896 5ZM4.40576 5.4375C5.41748 5.4375 6.25146 6.27148 6.25146 7.2832V7.84375C6.25146 8.21289 5.95068 8.5 5.59521 8.5H0.782715C0.413574 8.5 0.126465 8.21289 0.126465 7.84375V7.2832C0.126465 6.27148 0.946777 5.4375 1.9585 5.4375H2.19092C2.4917 5.58789 2.8335 5.65625 3.18896 5.65625C3.54443 5.65625 3.87256 5.58789 4.17334 5.4375H4.40576ZM8.82178 3.6875C8.89014 3.75586 8.89014 3.85156 8.82178 3.91992L6.89404 5.83398C6.82568 5.90234 6.72998 5.90234 6.66162 5.83398L5.54053 4.71289C5.48584 4.64453 5.48584 4.53516 5.54053 4.48047L5.92334 4.09766C5.9917 4.0293 6.10107 4.0293 6.15576 4.09766L6.78467 4.72656L8.22021 3.30469C8.2749 3.23633 8.38428 3.23633 8.43896 3.30469L8.82178 3.6875Z"
                  fill="var(--customizable-primary-color)" />
              </svg>
              {{ "REGISTER_AS_REFEREE" | transloco }}
            </button>
            <span
              *ngIf="(event | async)?.isSportshubOfficialRegistrationAllowed && (event | async)?.eventConfig?.configItems?.REGISTRATION_VOLUNTEER"
              class="volunteer">
              <button class="register-role-button " [disabled]="!checkRegistrationEnabled(event | async)"
                (click)="handleRegisterAsOfficial(RegistrationType.REGISTRATION_VOLUNTEER)">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path
                    d="M1.24045 6.89813L5.36744 10.7511C5.53874 10.9109 5.76484 11 6.00008 11C6.23532 11 6.46143 10.9109 6.63272 10.7511L10.7597 6.89813C11.454 6.25179 11.8468 5.34508 11.8468 4.39727V4.2648C11.8468 2.66836 10.6935 1.30716 9.11988 1.04452C8.07842 0.87094 7.0187 1.21124 6.27415 1.95579L6.00008 2.22986L5.72602 1.95579C4.98147 1.21124 3.92174 0.87094 2.88029 1.04452C1.30669 1.30716 0.15332 2.66836 0.15332 4.2648V4.39727C0.15332 5.34508 0.54615 6.25179 1.24045 6.89813Z"
                    fill="url(#paint0_linear_7603_11405)" />
                  <defs>
                    <linearGradient id="paint0_linear_7603_11405" x1="0.15332" y1="6" x2="11.8468" y2="6"
                      gradientUnits="userSpaceOnUse">
                      <stop stop-color="var(--customizable-primary-color)" />
                      <stop offset="1" stop-color="var(--sh-gradient-end, #CDD620)" />
                    </linearGradient>
                  </defs>
                </svg>
                {{ "REGISTER_AS_VOLUNTEER" | transloco }}
              </button>
            </span>
          </div>
        </div>

        <!-- <div *ngIf="isMembershipLicensing" class="licensing-description">
          <h3>{{ 'LICENSING_DESCRIPTION_TITLE' | transloco }}</h3>

          <p>
            <strong>{{ 'LICENSING_DESCRIPTION_GOAL' | transloco }}</strong>
          </p>

          <p>
            <strong>{{ 'LICENSING_DESCRIPTION_BENEFITS_TITLE' | transloco }}</strong>
          </p>

          <div class="benefit-item">
            {{ 'LICENSING_DESCRIPTION_BENEFIT_1' | transloco }}
          </div>
          <div class="benefit-item">
            {{ 'LICENSING_DESCRIPTION_BENEFIT_2' | transloco }}
          </div>
          <div class="benefit-item">
            {{ 'LICENSING_DESCRIPTION_BENEFIT_3' | transloco }}
          </div>
          <div class="benefit-item">
            {{ 'LICENSING_DESCRIPTION_BENEFIT_4' | transloco }}
          </div>
          <div class="benefit-item">
            {{ 'LICENSING_DESCRIPTION_BENEFIT_5' | transloco }}
          </div>
          <div class="benefit-item">
            {{ 'LICENSING_DESCRIPTION_BENEFIT_6' | transloco }}
          </div>
          <div class="benefit-item">
            {{ 'LICENSING_DESCRIPTION_BENEFIT_7' | transloco }}
          </div>
          <div class="benefit-item">
            {{ 'LICENSING_DESCRIPTION_BENEFIT_8' | transloco }}
          </div>
        </div> -->

        <!-- <div *ngIf="isClubMembershipEvent" class="c-club-m-descr-wrapper">
          <div class="c-club-descr-first-p-wrapper">
            <span class="c-club-m-descr-title">{{'DESCRIPTION' | transloco}} </span>

            <span [innerHTML]="(isClubNonProfitEvent
            ? 'CLUB_MEMBERSHIP_LANDING_DESCR_P_ONE_NON_PROFIT'
            : 'CLUB_MEMBERSHIP_LANDING_DESCR_P_ONE') | transloco : {nonAthleteMembershipUrl : nonAthleteMembershipUrl }" class="c-club-m-descr-p">
            </span>
          </div>

          <span *ngIf="!isClubNonProfitEvent" [innerHTML]="'CLUB_MEMBERSHIP_LANDING_DESCR_P_TWO' | transloco"
            class="c-club-m-descr-p">
          </span>

          <div *ngIf="isClubNonProfitEvent" class="c-club-descr-tier-items">
            <span [innerHTML]="'CLUB_MEMBERSHIP_LANDING_DESCR_TIERS_P_ONE' | transloco" class="c-club-m-descr-p">
            </span>
            <span [innerHTML]="'CLUB_MEMBERSHIP_LANDING_DESCR_TIERS_P_TWO' | transloco" class="c-club-m-descr-p">
            </span>
            <span [innerHTML]="'CLUB_MEMBERSHIP_LANDING_DESCR_TIERS_P_THREE' | transloco" class="c-club-m-descr-p">
            </span>
          </div>
        </div> -->


        <div class="line-info" *ngIf="currentEvent?.venue?.name || getLocation(currentEvent?.venue)">
          <img src="/assets/icons/location.svg" class="info-icon" />

          <div class="location-line">
            <span class="location-name">{{
              (event | async)?.venue?.name
              }}</span>
            <a class="info-content" target="_blank" [href]="getMapHref((event | async)?.venue)"
              (click)="preventNavigation($event, currentEvent?.venue)">{{ getLocation((event | async)?.venue) }}
            </a>
          </div>

          <a *ngIf="(event | async)?.venue" class="copy" target="_blank" (click)="copyLocationToClipBoard()">
            {{ "COPY" | transloco }}
          </a>
        </div>

        <div *ngIf="!isAAUMembership && (currentEvent?.phoneArray || []).length > 0" class="line-info">
          <img src="/assets/icons/phone.svg" class="info-icon" />

          <div>
            <div *ngFor="let phone of currentEvent?.phoneArray">
              <a class="info-content" href="tel:{{ phone }}" target="_blank">
                {{ phone }}
              </a>

              <a class="copy" target="_blank" (click)="copyToClipBoard(phone)">
                {{ "COPY" | transloco }}
              </a>
            </div>
          </div>
        </div>

        <div *ngIf="!isAAUMembership" class="event-date" [ngClass]="{ 'event-info-no-border-bottom': isAAUMembership }">
          <div *ngIf="(currentEvent?.emailArray || []).length > 0" class="line-info">
            <img src="/assets/icons/email.svg" class="info-icon" />

            <div>
              <div *ngFor="let email of currentEvent?.emailArray">
                <a target="_blank" class="info-content" href="mailto:{{ email }}?subject=Event:%20{{
                    currentEvent?.name
                  }}">
                  {{ email }}
                </a>
                <a class="copy" target="_blank" (click)="copyToClipBoard(email)">
                  {{ "COPY" | transloco }}
                </a>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="!isAAUMembership" class="public-files">
          <div *ngFor="let p of currentEvent?.publicFiles" class="line-info-alt"
            (click)="navigateToDownload(p.downloadLink.url)">
            <div class="info-icon-alt">
              <img src="/assets/icons/description.svg" class="public-files-img" />
            </div>
            <span class="download-link">{{ p.name }}</span>
            <img src="/assets/icons/download.svg" />
          </div>
        </div>

        <div class="description" *ngIf="(event | async)?.info" [ngClass]="{ 'c-description': isAAUMembership }">
          <span class="description__title">{{ "ABOUT" | transloco }}</span>
          <div>
            <span class="description__info" [innerHTML]="(event | async)?.info | safe : SafeTypes.html"></span>
          </div>
        </div>

        <div *ngIf="isAAUMembership" class="c-contact-buttons">
          <ng-container>
            <a href="https://support.aausports.org/Main/frmNewTicket.aspx?InstanceID=156e880d-572c-4e24-acf6-d737bf370c02"
              target="_blank" rel="noopener noreferrer">
              <div class="c-club-m-contact">
                <div class="c-club-m-contact-row">
                  <div class="c-club-m-contact-icon-details-wrapper">
                    <div class="c-club-m-contact-icon">
                      <div class="c-club-m-contact-icon-img">
                        <ng-container [ngTemplateOutlet]="questionIcon"></ng-container>
                      </div>
                    </div>

                    <div class="c-club-m-contact-details">
                      <span [innerHTML]="'IF_QUESTIONS_SUBMIT_A_TICKET' | transloco"
                        class="c-club-m-contact-details-title">
                      </span>

                      <!-- <span>{{email}}</span> -->
                    </div>
                  </div>

                  <div class="c-club-m-contact-icon-img-arrow">
                    <ng-container [ngTemplateOutlet]="arrowRightIcon"></ng-container>
                  </div>
                </div>
              </div>
            </a>
          </ng-container>
        </div>
      </div>

      <div class="wrap-carousel" *ngIf="!isUseEventLicenseFlyer">
        <div class="event-gallery__featured" [ngClass]="{
            onlyImage: !(processedImages && processedImages.length > 1)
          }">
          <owl-carousel-o [options]="customOptions" #owlCar (changed)="changedByNav($event)">
            <ng-container *ngFor="let image of processedImages">
              <ng-template carouselSlide [id]="image.url">
                <img #owlCarBanner [src]="image.url" [ngClass]="getAspectRatioClass(image)" (click)="
                    openImg({ url: image.url, banners: processedImages })
                  " />
              </ng-template>
            </ng-container>
          </owl-carousel-o>
        </div>


        <div class="event-gallery__carousel" *ngIf="processedImages && processedImages.length > 1">
          <owl-carousel-o [options]="{ dots: false, margin: 5, autoWidth: true }">
            <ng-container *ngFor="let image of processedImages; let i = index">
              <ng-template carouselSlide [id]="image.url" [width]="80">
                <a (click)="owlCar.to(image.url); changeImage(image.url)">
                  <img class="max-width-heigth" [src]="image.url" [ngClass]="{
                      'event-gallery__carousel-item--active':
                        selectedImage === image.url ||
                        (i == 0 && !selectedImage)
                    }" />
                </a>
              </ng-template>
            </ng-container>
          </owl-carousel-o>
        </div>
      </div>

      <div class="wrap-carousel" *ngIf="isUseEventLicenseFlyer">
        <div #container class="pdf-thumb"
          (click)="openImg({ url: aauEventLicenseFlyerPreviewUrl, banners: [{ url: aauEventLicenseFlyerPreviewUrl }] })"
          style="cursor: pointer;">
          <canvas #canvas *ngIf="!aauEventLicenseFlyerImageUrl"></canvas>
          <img *ngIf="aauEventLicenseFlyerImageUrl" [src]="aauEventLicenseFlyerImageUrl" width="100%" />
        </div>
      </div>

    </div>
  </div>
</div>

<ng-template #emailIcon>
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
    <g clip-path="url(#clip0_6578_123860)">
      <path
        d="M2.375 3.35156C1.33984 3.35156 0.5 4.19141 0.5 5.22656C0.5 5.81641 0.777344 6.37109 1.25 6.72656L9.75 13.1016C10.1953 13.4336 10.8047 13.4336 11.25 13.1016L19.75 6.72656C20.2227 6.37109 20.5 5.81641 20.5 5.22656C20.5 4.19141 19.6602 3.35156 18.625 3.35156H2.375ZM0.5 7.72656V15.8516C0.5 17.2305 1.62109 18.3516 3 18.3516H18C19.3789 18.3516 20.5 17.2305 20.5 15.8516V7.72656L12 14.1016C11.1094 14.7695 9.89062 14.7695 9 14.1016L0.5 7.72656Z"
        fill="#F3F6F6" />
    </g>
    <defs>
      <clipPath id="clip0_6578_123860">
        <rect width="20" height="20" fill="white" transform="translate(0.5 0.851562)" />
      </clipPath>
    </defs>
  </svg>
</ng-template>

<ng-template #phoneIcon>
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
    <path
      d="M19.73 16.1113L17.19 15.8213C16.58 15.7513 15.98 15.9613 15.55 16.3913L13.71 18.2313C10.88 16.7913 8.56004 14.4813 7.12004 11.6413L8.97004 9.79133C9.40004 9.36133 9.61004 8.76133 9.54004 8.15133L9.25004 5.63133C9.13004 4.62133 8.28004 3.86133 7.26004 3.86133H5.53004C4.40004 3.86133 3.46004 4.80133 3.53004 5.93133C4.06004 14.4713 10.89 21.2913 19.42 21.8213C20.55 21.8913 21.49 20.9513 21.49 19.8213V18.0913C21.5 17.0813 20.74 16.2313 19.73 16.1113Z"
      fill="white" />
  </svg>
</ng-template>

<ng-template #arrowRightIcon>
  <svg xmlns="http://www.w3.org/2000/svg" width="41" height="41" viewBox="0 0 41 41" fill="none">
    <path
      d="M20.0165 26.334L24.3332 22.0173C24.9832 21.3673 24.9832 20.3173 24.3332 19.6673L20.0165 15.3507C18.9665 14.3007 17.1665 15.0507 17.1665 16.534L17.1665 25.1673C17.1665 26.6507 18.9665 27.384 20.0165 26.334Z"
      fill="var(--customizable-primary-color)" />
  </svg>
</ng-template>

<ng-template #questionIcon>
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
    <path
      d="M18.8307 9.9974C18.8307 14.6008 15.0994 18.3307 10.4974 18.3307C5.89535 18.3307 2.16406 14.6008 2.16406 9.9974C2.16406 5.39669 5.89535 1.66406 10.4974 1.66406C15.0994 1.66406 18.8307 5.39669 18.8307 9.9974ZM10.721 4.41944C8.8898 4.41944 7.72186 5.19084 6.80472 6.56184C6.6859 6.73947 6.72566 6.97902 6.89595 7.10815L8.06191 7.99222C8.23681 8.12485 8.486 8.0933 8.62189 7.92092C9.22216 7.15956 9.63375 6.71806 10.5474 6.71806C11.2339 6.71806 12.0829 7.15986 12.0829 7.82552C12.0829 8.32875 11.6675 8.58718 10.9897 8.96719C10.1993 9.4103 9.15331 9.96181 9.15331 11.3415V11.4759C9.15331 11.6986 9.33385 11.8791 9.55654 11.8791H11.4383C11.6609 11.8791 11.8415 11.6986 11.8415 11.4759V11.4311C11.8415 10.4747 14.6367 10.4349 14.6367 7.84686C14.6367 5.89787 12.615 4.41944 10.721 4.41944ZM10.4974 12.7528C9.64508 12.7528 8.9517 13.4462 8.9517 14.2985C8.9517 15.1508 9.64508 15.8442 10.4974 15.8442C11.3497 15.8442 12.0431 15.1508 12.0431 14.2985C12.0431 13.4462 11.3497 12.7528 10.4974 12.7528Z"
      fill="#F3F6F6" />
  </svg>
</ng-template>

<ng-template #pdfPreview>
</ng-template>